/**
 * Client-side mirror of the server import limits.
 *
 * Source of truth: `apps/api/src/services/import/constants.ts`. `apps/app` cannot import from
 * `apps/api`, so these are duplicated deliberately (plan U12). If the server constants change,
 * change these too.
 */

/** Largest CSV we will post inline as `ImportSourceInput.csv`. */
export const IMPORT_MAX_INLINE_BYTES = 2 * 1024 * 1024

/** Server rejects files with more data rows than this. */
export const IMPORT_MAX_ROWS = 5000

/** Server rejects files with more columns than this. */
export const IMPORT_MAX_COLUMNS = 100

/** At or below this row count the wizard shows live progress instead of the email screen. */
export const IMPORT_INLINE_ROW_LIMIT = 500

/** Server stores at most this many row errors on an ImportJob. */
export const IMPORT_MAX_STORED_ERRORS = 1000

/** How often the inline path polls `importJob`, in milliseconds. */
export const IMPORT_POLL_INTERVAL_MS = 2000

/** Human-readable form of IMPORT_MAX_INLINE_BYTES, for copy. */
export const IMPORT_MAX_INLINE_LABEL = '2 MB'
